import type { CSSProperties, MouseEvent } from 'react';

import { Sticky } from 'react-sticky';

import HamburgerMenu from 'src/app/components/Elements/HamburgerMenu';
import { HeaderLogoLink } from 'src/app/components/Elements/HeaderLogoLink';
import { HorizontalProgressBar } from 'src/app/components/Elements/ProgressBars/HorizontalProgressBar/index';
import { redirectHome } from 'src/app/router/paths';
import { setPreviousOnboardingStep } from 'src/app/state/actions';
import { useDispatch } from 'src/app/state/store';

import { NavTheme, ResponsiveView } from '../../constants';
import { BottomNav, LeftNav, MobileHeaderContainer, MobileIconContainer, NavWrapper, RightNav } from '../../styles';

interface LeftNavIconProps {
  currentStepIndex: number;
  handlePreviousClick: (currentStepIndex: number) => () => void;
  handleToggleMenu: (e: MouseEvent) => void;
  isOnboardingFlow: boolean;
  navTheme: NavTheme;
  showMenu: boolean;
}

const LeftNavIcon = ({ handleToggleMenu, navTheme, showMenu }: LeftNavIconProps) => {
  if (!showMenu) {
    return (
      <HamburgerMenu
        isActive={showMenu}
        onClick={handleToggleMenu}
        isWhite={navTheme === NavTheme.blue}
        aligned={'left'}
      />
    );
  }

  return null;
};

interface MobileHeaderProps {
  currentStepIndex: number;
  handleToggleMenu: (e: MouseEvent) => void;
  isOnboardingFlow: boolean;
  navOpacity: number;
  navTheme: NavTheme;
  progressBarFillPercent: number;
  progressBarTotalSteps: number;
  showMenu: boolean;
  stickyTopOffset: number;
}

export const MobileHeader = ({
  currentStepIndex,
  handleToggleMenu,
  isOnboardingFlow,
  navOpacity,
  navTheme,
  progressBarFillPercent,
  progressBarTotalSteps,
  showMenu,
  stickyTopOffset,
}: MobileHeaderProps) => {
  const dispatch = useDispatch();

  const handlePreviousClick = (currentStepIndex: number) => () =>
    currentStepIndex === 0 ? redirectHome() : dispatch(setPreviousOnboardingStep());

  return (
    <Sticky topOffset={stickyTopOffset}>
      {({ style }: { style: CSSProperties }) => (
        <NavWrapper
          style={{ opacity: navOpacity, ...style }}
          responsiveView={ResponsiveView.mobile}
          navTheme={navTheme}
          hasFlexWrap={isOnboardingFlow}
          isOnboardingFlow={isOnboardingFlow}
        >
          <MobileHeaderContainer>
            <LeftNav>
              <LeftNavIcon
                currentStepIndex={currentStepIndex}
                handlePreviousClick={handlePreviousClick}
                handleToggleMenu={handleToggleMenu}
                isOnboardingFlow={isOnboardingFlow}
                navTheme={navTheme}
                showMenu={showMenu}
              />
            </LeftNav>
            <MobileIconContainer>{!showMenu && <HeaderLogoLink />}</MobileIconContainer>
            <RightNav />
          </MobileHeaderContainer>

          {isOnboardingFlow && (
            <BottomNav showMenu={showMenu}>
              <HorizontalProgressBar
                currentStep={currentStepIndex + 1}
                totalSteps={progressBarTotalSteps}
                fillPercent={progressBarFillPercent}
                size={'large'}
                isHiddenOnDesktop={false}
                hasLargeBorderRadius
              />
            </BottomNav>
          )}
        </NavWrapper>
      )}
    </Sticky>
  );
};
